<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #default>

        <t-input v-model="form.labelId" hidden/>

        <t-form-card title="Etiqueta" class="mt-2">

          <b-row>

            <t-input cols="4"
                     v-model="form.labelNumber"
                     label="Código"
                     fixed
                     highlight/>

            <t-input cols="8"
                     v-model="form.name"
                     label="Nome"
                     fixed/>

          </b-row>

          <t-input v-model="form.note"
                   label="Observações"
                   textarea
                   fixed/>

        </t-form-card>


        <t-form-card title="Versionamento" class="mt-3">

          <b-row>

            <t-input cols="4"
                     v-model="form.versionCurrent"
                     label="Versão Atual"
                     number
                     fixed/>

            <t-input cols="4"
                     v-model="form.versionChanged"
                     label="Data da Versão"
                     date
                     fixed/>

            <t-input cols="4"
                     v-model="form.versionDetails"
                     label="Detalhes da Versão"
                     textarea
                     fixed/>

          </b-row>

        </t-form-card>


        <t-form-card title="Restritir Quantidade de Impressão" class="mt-3" v-if="form.businessRuleType === 'production-order' || form.businessRuleType === 'production-expedition'">

          <t-msg info>
            Informe a quantidade máxima de etiquetas permitida para cada tipo de embalagem.
            Quando a quantidade estiver em branco, não haverá restrição para aquela unidade.
          </t-msg>

          <t-table
              :items="unitRestrictionList"
              :fields="unitRestrictionFields"
              disable-link-primary-column
              disable-actions-column
              table-bordered
              table-striped
              primary-key-column="unitId"
              class="mb-2">

            <template #first-column="{item}">
              {{ item.text }}
            </template>

            <template #item(allowedQuantity)="{item}">

              <t-input
                  v-model="item.allowedQuantity"
                  hide-label
                  number
                  placeholder="Sem restrição"/>

            </template>

            <template #item(requiredSubValidationReprint)="{item}">

              <b-form-checkbox
                  v-model="item.requiredSubValidationReprint"
                  switch>
                Exigir validação especial
              </b-form-checkbox>

            </template>

          </t-table>

        </t-form-card>


        <t-form-card title="Template Atual" class="mt-3">

          <b-row>

            <b-col cols="12">

              <div class="label-template-preview">

                <img v-if="form.template"
                     :src="form.template"

                     alt="Template da etiqueta"
                     class="label-template-image"/>

                <div v-else class="text-muted text-center py-4">
                  Nenhum template disponível para esta etiqueta.
                </div>

              </div>

            </b-col>

          </b-row>

        </t-form-card>



      </template>

    </t-page-form>

  </t-page>

</template>



<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import unitService from "@/services/modules/product/Unit.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'LabelForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "labelId",
      form: {
        labelId: 0,
        labelNumber: 0,
        name: "",
        note: "",
        template: "",
        businessRuleType: "",
        versionCurrent: "",
        versionChanged: "",
        versionDetails: "",
        status: 1,
        unitRestrictions:[],

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      unitOptions: [],
      unitRestrictionList: [],
      unitRestrictionFields: [
        {
          key: "name",
          label: "Unidade / Embalagem",
          help: "Tipo de unidade ou embalagem da Ordem de Fabricação para a qual a regra de impressão será aplicada."
        },
        {
          key: "allowedQuantity",
          label: "Qtd. de Vias Permitida",
          help: "Informe a quantidade máxima de vias permitidas na primeira impressão. Deixe em branco quando não houver restrição de quantidade para esta unidade."
        },
        {
          key: "requiredSubValidationReprint",
          label: "Validação na Reimpressão",
          help: "Quando habilitado, qualquer nova impressão após a primeira deverá passar por uma validação especial. Para permitir a impressão de uma 2ª via, o usuário deverá possuir a permissão correspondente em seu Perfil de Acesso. Procure por: 'Permissão para Reimpressão de Etiqueta (2ª via)'"
        }
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      await unitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))

      this.prepareUnitRestrictionList()

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      this.form.unitRestrictions = []

      for (let item of this.unitRestrictionList) {

        if (
            item.allowedQuantity !== null &&
            item.allowedQuantity !== undefined &&
            item.allowedQuantity !== ""
        ) {

          const unitRestriction = {
            unitId: item.unitId,
            allowedQuantity: item.allowedQuantity,
            requiredSubValidationReprint: item.requiredSubValidationReprint
          }

          this.form.unitRestrictions.push(unitRestriction)

        }

      }


      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    prepareUnitRestrictionList() {

      this.unitRestrictionList = []

      for (let item of this.unitOptions) {

        const restriction = this.form.unitRestrictions.find(
            a => a.unitId === item.value
        )

        this.unitRestrictionList.push({
          unitId: item.value,
          text: item.text,
          allowedQuantity: restriction
              ? restriction.allowedQuantity
              : null,
          requiredSubValidationReprint: restriction
              ? restriction.requiredSubValidationReprint
              : false
        })

      }

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
<style scoped>

.label-template-preview {
  width: 100%;
  min-height: 180px;
  padding: 20px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #f8f9fa;
  text-align: center;
}

.label-template-image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

</style>
